export default __webpack_public_path__ + "static/img_768-0711e5c06871e3d4787e163d1794434f.jpg";